import { useState } from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"

type EditableTimeEntry = {
  id: string
  date: string
  hours: number
  description: string
}

export function EditTimeEntryDialog({
  entry,
  onOpenChange,
  open,
}: {
  entry: EditableTimeEntry
  onOpenChange: (open: boolean) => void
  open: boolean
}) {
  const [form, setForm] = useState({
    date: entry.date,
    description: entry.description,
    hours: String(entry.hours),
  })

  function handleSubmit() {
    router.patch(`/time_entries/${entry.id}`, {
      date: form.date,
      hours: Number(form.hours),
      description: form.description,
    }, {
      onSuccess: () => onOpenChange(false),
      preserveScroll: true,
    })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit time entry</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3">
          <div className="grid grid-cols-2 gap-2.5">
            <div className="flex flex-col gap-1">
              <Label htmlFor="edit-entry-date">Date</Label>
              <Input
                id="edit-entry-date"
                type="date"
                value={form.date}
                onChange={(e) => setForm((f) => ({ ...f, date: e.target.value }))}
                
              />
            </div>
            <div className="flex flex-col gap-1">
              <Label htmlFor="edit-entry-hours">Hours</Label>
              <Input
                id="edit-entry-hours"
                type="number"
                min="0.5"
                max="24"
                step="0.5"
                placeholder="8"
                value={form.hours}
                onChange={(e) => setForm((f) => ({ ...f, hours: e.target.value }))}
                
              />
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-entry-description">Description</Label>
            <Input
              id="edit-entry-description"
              placeholder="What was worked on"
              value={form.description}
              onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
              
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button size="sm" onClick={handleSubmit} disabled={!form.date || !form.hours || !form.description}>
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
